//AddressAlert.js

import React, { useEffect, useState } from 'react';
import axios from '../utils/axiosConfig'; //新增CSRF設定
import API_URL from '../config';
import { useTranslation } from 'react-i18next'; // 引入 i18n
import { useNavigate } from 'react-router-dom'; // 引入 useNavigate


function WebhookAdmin() {
  const [webhooks, setWebhooks] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [newAddresses, setNewAddresses] = useState("");

  // 初次載入時，列出所有 Webhooks
  useEffect(() => {
    fetchWebhooks();
  }, []);

  const fetchWebhooks = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/webhooks`);
      console.log(res.data);
      console.log(Array.isArray(res.data));
      setWebhooks(res.data);
    } catch (err) {
      console.error("fetchWebhooks error:", err);
      alert("無法取得 Webhooks");
    }
  };

  // 刪除
  const deleteWebhook = async (id) => {
    if (!window.confirm(`確定要刪除 Webhook: ${id}？`)) return;
    try {
      await axios.delete(`/api/helius/webhooks/${id}`);
      alert("刪除成功");
      fetchWebhooks();
    } catch (err) {
      console.error("deleteWebhook error:", err);
      alert("刪除失敗:" + err.message);
    }
  };

  // 更新地址 (會覆蓋整個 addresses)
  const updateAddresses = async () => {
    if (!selectedId) {
      alert("請先選擇要更新的 Webhook ID");
      return;
    }
    try {
      // 以逗號分隔 input 來得到地址陣列
      const addressesArray = newAddresses.split(",").map((s) => s.trim()).filter(Boolean);

      await axios.patch(`${API_URL}/api/webhooks/${selectedId}/addresses`, {
        addresses: addressesArray,
      });
      alert("更新成功");
      fetchWebhooks();
    } catch (err) {
      console.error("updateAddresses error:", err);
      alert("更新失敗:" + err.message);
    }
  };

  return (
    <div>
      <h2>Webhook Admin</h2>

      <div style={{ marginBottom: "16px" }}>
        <button onClick={fetchWebhooks}>重新載入列表</button>
      </div>

      <table border="1" cellPadding="8">
        <thead>
          <tr>
            <th>Webhook ID</th>
            <th>URL</th>
            <th>Addresses</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {webhooks.map((wh) => (
            <tr key={wh.id}>
              <td>{wh.webhookID}</td>
              <td>{wh.webhookURL}</td>
              <td>{(wh.accountAddresses || []).join(", ")}</td>
              <td>
                <button onClick={() => deleteWebhook(wh.webhookID)}>刪除</button>
                <button onClick={() => setSelectedId(wh.webhookID)}>選擇</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ marginTop: "16px", border: "1px solid #ccc", padding: "12px" }}>
        <h3>更新地址 (選擇上方 Webhook 後)</h3>
        <p>目前選擇的 Webhook ID：{selectedId || "(尚未選擇)"}</p>
        <div>
          <label>新的 addresses (逗號分隔)：</label>
          <input
            type="text"
            value={newAddresses}
            onChange={(e) => setNewAddresses(e.target.value)}
          />
        </div>
        <button onClick={updateAddresses}>送出更新</button>
      </div>
    </div>
  );
}

export default WebhookAdmin;
